import Component from '@bythepixel/component-loader';

export default class LocationSearchField extends Component {
  static selector = '[data-comp-location-search-field]';

  options = [];

  constructor(containerEl, options) {
    super(containerEl, options);

    // Highlights the input text when focused
    this.$container
      .querySelector('input')
      ?.addEventListener('focus', (e) => e.target.select());

    this.inputEl = this.$container.querySelector('input');

    this.inputEl.addEventListener('keydown', this.onKeyDown.bind(this));
    this.listEl = this.$container.querySelector('[role="listbox"]');

    const observer = new MutationObserver(() => this.resetOptions());
    observer.observe(this.listEl, { childList: true });
  }

  resetOptions() {
    this.options = this.listEl.querySelectorAll('[role="option"]');
    this.activeIndex = -1;
  }

  onKeyDown(e) {
    switch (e.key) {
    case 'ArrowDown':
      this.moveFocus(1);
      break;
    case 'ArrowUp':
      this.moveFocus(-1);
      break;
    case 'Enter':
      if (this.activeIndex >= 0) {
        this.options[this.activeIndex].click();
      }
      break;
    case 'Escape':
      this.inputEl.blur();
      break;
    default:
      break;
    }
  }

  moveFocus(direction) {
    if (this.options.length === 0) return;

    this.activeIndex = (this.activeIndex + direction + this.options.length)
      % this.options.length;

    this.options.forEach((option, index) => {
      option.setAttribute('aria-selected', index === this.activeIndex);
    });

    this.inputEl.setAttribute(
      'aria-activedescendant',
      this.options[this.activeIndex].id,
    );
  }
}
